import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

const reports = accountId => ({
  parentNav: 'reports',
  routes: [
    'account_overview_reports',
    'conversation_reports',
    'csat_reports',
    'bot_reports',
    'agent_reports',
    'label_reports',
    'inbox_reports',
    'team_reports',
    'campaign_reports',
    'statement_reports',
    'tabulacao_reports',
    'search_interaction',
    'exportar_reports',
    'logins_reports',
    'call_reports',
    'sla_reports',
  ],
  menuItems: [
    {
      icon: 'arrow-trending-lines',
      label: 'REPORTS_OVERVIEW',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/overview`),
      toStateName: 'account_overview_reports',
    },
    {
      icon: 'chat',
      label: 'REPORTS_CONVERSATION',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/conversation`),
      toStateName: 'conversation_reports',
    },
    {
      icon: 'emoji',
      label: 'CSAT',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/csat`),
      toStateName: 'csat_reports',
    },
    {
      icon: 'bot',
      label: 'REPORTS_BOT',
      hasSubMenu: false,
      featureFlag: FEATURE_FLAGS.RESPONSE_BOT,
      toState: frontendURL(`accounts/${accountId}/reports/bot`),
      toStateName: 'bot_reports',
    },
    {
      icon: 'people',
      label: 'REPORTS_AGENT',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/agent`),
      toStateName: 'agent_reports',
    },
    {
      icon: 'tag',
      label: 'REPORTS_LABEL',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/label`),
      toStateName: 'label_reports',
    },
    {
      icon: 'mail-inbox-all',
      label: 'REPORTS_INBOX',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/inboxes`),
      toStateName: 'inbox_reports',
    },
    {
      icon: 'people-team',
      label: 'REPORTS_TEAM',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/teams`),
      toStateName: 'team_reports',
    },
    {
      icon: 'megaphone',
      label: 'REPORTS_CAMPAIGN',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/campaigns`),
      toStateName: 'campaign_reports',
    },
    {
      icon: 'arrow-trending-lines',
      label: 'REPORTS_STATEMENT',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/statement`),
      toStateName: 'statement_reports',
    },
    {
      icon: 'tag',
      label: 'REPORTS_TABULATION',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/tabulacao`),
      toStateName: 'tabulacao_reports',
    },
    {
      icon: 'tag',
      label: 'SEARCH_REPORTS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/search_interaction`),
      toStateName: 'search_interaction',
    },
    {
      icon: 'tag',
      label: 'CALL_REPORTS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/call_reports`),
      toStateName: 'call_reports',
    },
    {
      icon: 'tag',
      label: 'REPORTS_EXPORTAR',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/exportar`),
      toStateName: 'exportar_reports',
    },
    {
      icon: 'document-list-clock',
      label: 'REPORTS_SLA',
      hasSubMenu: false,
      featureFlag: FEATURE_FLAGS.SLA,
      toState: frontendURL(`accounts/${accountId}/reports/sla`),
      toStateName: 'sla_reports',
    },
    {
      icon: 'tag',
      label: 'REPORTS_LOGINS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/logins`),
      toStateName: 'logins_reports',
      beta: true,
    },
  ],
});

export default reports;
